import React from 'react';

import { Typography } from 'antd';
import styled from 'styled-components';

import { getFormattedDate } from 'helpers/dates';

import { useEditShopRequestModalContext } from './EditShopRequestModalContext';
import EditShopRequestModalStatus from './EditShopRequestModalStatus';
import EditShopRequestModalUserSelect from './EditShopRequestModalUserSelect';
import { REPEAT_LABELS } from '../constants';

const Container = styled.div`
  display: flex;
  flex-flow: column;
  width: 100%;
  border-bottom: solid 1px var(--line-gray);
  padding: 0 30px 10px 30px;
  box-sizing: border-box;
`;

const Subtitle = styled(Typography.Text)`
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  color: var(--text-secondary);
  margin-bottom: 30px;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px 24px;
`;

const FlexContainer = styled.div`
  display: flex;
  flex-grow: 1;
  gap: 12px;
`;

const Label = styled(Typography.Text)`
  color: var(--text-secondary);
  white-space: nowrap;
`;

const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

const EditShopRequestModalHeader = () => {
  const { shopRequest } = useEditShopRequestModalContext();
  const requestFrom = shopRequest?.requestGroup?.company ? 'Company' : 'Further';
  const shopper = shopRequest?.shopper && `, via ${shopRequest.shopper.name}`;
  const companyName =
    shopRequest?.requestGroup?.company && `, on behalf of ${shopRequest?.requestGroup?.company?.name}`;
  return (
    <Container>
      <Subtitle data-test-id="sr-modal-subtitle">
        {REPEAT_LABELS[shopRequest!.repeat]} · Requested by {requestFrom}
        {shopper}
        {companyName}
      </Subtitle>
      <Row>
        <FlexContainer>
          <EditShopRequestModalUserSelect field="shopper" label="Shopper" />
          <EditShopRequestModalUserSelect field="auditor" label="Auditor" />
        </FlexContainer>
        <StatusContainer>
          <Label>
            Added {getFormattedDate(shopRequest!.created_at, 'MMMM DD')} · Due{' '}
            {getFormattedDate(shopRequest!.dueDate, 'MMMM DD')}
          </Label>
          <EditShopRequestModalStatus />
        </StatusContainer>
      </Row>
    </Container>
  );
};

export default EditShopRequestModalHeader;
